import { TENANT_AT, TENANT_COM, TENANT_IT } from 'shared/consts/tenants'
import { SERP_FILTERING } from 'shared/experiments/consts'
import { PAGE_TYPE_SEARCH_RESULTS } from 'shared/consts/page'

import store from 'shared/store'
import { isDesktop, isTablet } from 'shared/utils/deviceClassUtils'
import { isExperimentEnabled } from 'shared/experiments/utils'

const ALLOWED_TENANTS = [TENANT_COM, TENANT_AT, TENANT_IT]

export const isSerpFilteringExperimentActive = (variation: string): boolean => {
  const publicRuntimeConfig = store.getState()?.publicRuntimeConfig
  const { tenant, deviceClass } = publicRuntimeConfig?.publicConfig || {}
  const { pageType } = publicRuntimeConfig?.pageProperties || {}

  return Boolean(
    pageType === PAGE_TYPE_SEARCH_RESULTS &&
      ALLOWED_TENANTS.includes(tenant) &&
      (isTablet(deviceClass) || isDesktop(deviceClass)) &&
      isExperimentEnabled(SERP_FILTERING) &&
      document.querySelector(
        `[data-experiment="${SERP_FILTERING}"][data-experiment-variation="${variation}"]`
      )
  )
}
